const followKeys = {
  base: ["follows"] as const,
  lists: () => [...followKeys.base, "list"] as const,
  users: () => [...followKeys.lists(), "users"] as const,
  user: (id: string) => [...followKeys.users(), id] as const,
  artists: () => [...followKeys.lists(), "artists"] as const,
  artist: (id: string) => [...followKeys.artists(), id] as const,
};

const followerKeys = {
  base: ["followers"] as const,
  lists: () => [...followerKeys.base, "list"] as const,
  list: (artistId: string) => [...followerKeys.lists(), artistId] as const,
};

export { followKeys, followerKeys };
